import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";

// Wires `entity = editMode ? getExampleEntity : getRealEntity` so the
// Change* settings inputs render with sensible defaults instead of
// crashing on `entity.firstName` / etc.
export const UserSettingsPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  methods: {
    getExampleEntity() {
      return {
        userId: 1,
        firstName: "First",
        lastName: "Last",
        username: "username",
        email: "user@example.com",
        bio: "Example bio",
        avatarUrl: "",
        splashImageUrl: "",
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
